import useFundsTransferStore from "../../../stores/fundsTransferStore";
import { Headers } from "../../ui/heading";

export function FundsTransferPageHeader() {
  const currentStep = useFundsTransferStore((state) => state.currentStep);

  if (currentStep >= 4) return null;

  return (
    <Headers
      name="Funds Transfer"
      subtitle="Withdraw funds to your mobile money, bank, or Paykit account"
    />
  );
}
